import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
const apiServer = environment.apiBase;
const apiAssetBaseUrl = environment.apiAssetBase;
const apiHrmServer = environment.apiHrmBase;
const apiConfigServer = environment.apiConfigBase;
const apiCoreBaseUrl = environment.apiCoreBase;

@Injectable()
export class ApiService {
  constructor(
    private http: HttpClient,
    private authService: AuthService) { }

  options = {
    headers: new HttpHeaders({
      Authorization: this.authService.getAuthorizationHeaderValue(),
      'Content-Type': 'application/json',
    })
  };

  postApi(url, data): Observable<any> {
    return this.http.post(url, data, this.options);
  }

  getApi(url): Observable<any> {
    return this.http.get(url, this.options);
  }

  apiTesst(): Observable<any> {
    return this.http
      .get<any>(`https://printer.sunshinegroup.vn:8080/api/printer`);
  }

  // Đơn vị tính

  getUnitPage(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/store/GetPage?${queryParams}`, this.options);
  }

  clientMenuGetListByUserId(queryParams): Observable<any> {
    return this.http.get(`${apiConfigServer}/api/v1/webmanager/ClientMenuGetListByUserId?` + queryParams, this.options);
  }

  getWebMenuListByUserId(queryParams): Observable<any> {
    return this.http.get(`${apiConfigServer}/api/v1/webmanager/GetWebMenuListByUserId?` + queryParams, this.options);
  }

  getUnitInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/store/GetInfo?${queryParams}`, this.options);
  }

  setUnitInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/store/SetInfo`, queryParams, this.options);
  }

  delUnitInfo(queryParams: any): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/store/Delete?${queryParams}`, this.options);
  }

  importUnit(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/store/Import`, queryParams, {
      headers: new HttpHeaders({
        Authorization: this.authService.getAuthorizationHeaderValue(),
        'accept': '*/*'
      })
    });
  }

  // api kho hàng

  getAssetDiaryPage(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/assetDiary/GetPage?${queryParams}`, this.options);
  }

  getAssetDiaryInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/assetDiary/GetInfo?${queryParams}`, this.options);
  }

  setAssetDiaryInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/assetDiary/SetInfo`, queryParams, this.options);
  }

  delAssetDiaryInfo(queryParams: any): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/assetDiary/Delete?${queryParams}`, this.options);
  }

  importAssetDiary(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/assetDiary/Import`, queryParams, {
      headers: new HttpHeaders({
        Authorization: this.authService.getAuthorizationHeaderValue(),
        'accept': '*/*',
      })
    });
  }

  // Lấy danh sách người dùng đã sử dụng tài sản trong hệ thống

  getListUserPage(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/assetDiary/GetListUser?${queryParams}`, this.options);
  }

   // api kho hàng

   getWarehousePage(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Warehouse/GetPage?${queryParams}`, this.options);
  }

  getWarehouseInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Warehouse/GetInfo?${queryParams}`, this.options);
  }

  setWarehouseInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Warehouse/SetInfo`, queryParams, this.options);
  }

  delWarehouseInfo(queryParams: any): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/Warehouse/Delete?${queryParams}`, this.options);
  }

  importWarehouse(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Warehouse/Import`, queryParams, {
      headers: new HttpHeaders({
        Authorization: this.authService.getAuthorizationHeaderValue(),
        'accept': '*/*',
      })
    });
  }

  // api Tài sản

  getAssetPage(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetPage?${queryParams}`, this.options);
  }

  getAssetOverviewPage(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetPageOverview?${queryParams}`, this.options);
  }

  assetDashBoardGet(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/AssetDashBoardGet?${queryParams}`, this.options);
  }

  getAssetInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetInfo?${queryParams}`, this.options);
  }

  getAssetEvictionInfo(id): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetAssetEvictionInfo?id=${id}`, this.options);
  }

  getDetailViewInfo(id): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetDetailViewInfo?id=${id}`, this.options);
  }

  getDetailInfo(id) :Observable<any> {{
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetDetailInfo?id=${id}`, this.options);
  }}

  getApiCauHinh(path,queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/${path}?${queryParams}`, this.options);
  }

  setApiCauHinh(path,params: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/asset/${path}`, params, this.options);
  }

  getAssetStatus(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/AssetStatus/GetPage?${queryParams}`, this.options);
  }
  getRecentlyCreatedPage(gridWidth = 0): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetRecentlyCreatedPage?gridWidth=${gridWidth}`, this.options);
  }

  setAssetInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/asset/SetInfo`, queryParams, this.options);
  }

  delAssetInfo(queryParams: any): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/asset/Delete?${queryParams}`, this.options);
  }

  asssetMultiDel(id): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/asset/AssetMultiDel?id=${id}`, this.options);
  }

  importAsset(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/asset/Import`, queryParams, {
      headers: new HttpHeaders({
        Authorization: this.authService.getAuthorizationHeaderValue(),
        'accept': '*/*',
      })
    });
  }
  getStatusPieChart(): Observable<any[]> {
    return this.http
      .get<any[]>(`${apiAssetBaseUrl}/api/v1/asset/GetStatusPieChart`, this.options)
  }

  AssetAllocationInfo(queryParams:any):Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/asset/AssetAllocationInfo`, queryParams, this.options);
  }

  AssetTransferInfo(queryParams:any):Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/asset/AssetTransferInfo`, queryParams, this.options);
  }

  getListOrganizes(): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetListOrganizes`, this.options);
  }

  getListDepartmentByOrg(orgId: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetListDepartmentByOrg?orgId=${orgId}`, this.options);
  }

  getListEmployees(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetListEmployees?${queryParams}`, this.options)
  }

  getListSuggestAssetName(name): Observable<any> {
    return this.http.get<any>(`${apiAssetBaseUrl}/api/v1/asset/GetListSuggestAssetName?name=${name}`, this.options)
  }

   // api nhà cung cấp

  getSupplierPage(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Supplier/GetPage?${queryParams}`, this.options);
  }

  getOrgRoots(): Observable<any> {
    return this.http.get<any>(`${apiHrmServer}/api/v1/organize/GetOrgRoots`, this.options)
  }

  getUserByPush(queryParams): Observable<any> {
    return this.http.put<any>(`${apiHrmServer}/api/v1/notify/GetUserByPush` , queryParams, this.options)
  }

  getSupplierInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Supplier/GetInfo?${queryParams}`, this.options);
  }
  getOrganizePage(queryParams: any): Observable<any> {
    return this.http.get(`${apiHrmServer}/api/v1/organize/GetOrganizePage?${queryParams}`, this.options);
  }

  setSupplierInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Supplier/SetInfo`, queryParams, this.options);
  }

  delSupplierInfo(queryParams: any): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/Supplier/Delete?${queryParams}`, this.options);
  }

  importSupplierInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Supplier/Import`, queryParams, {
      headers: new HttpHeaders({
        Authorization: this.authService.getAuthorizationHeaderValue(),
        'accept': '*/*',
      })
    });
  }

  // api nhóm tài sản
  getAssetCategoryPage(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/assetCategory/GetPage?${queryParams}`, this.options);
  }

  getAssetCategoryInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/assetCategory/GetInfo?${queryParams}`, this.options);
  }

  setAssetCategoryInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/assetCategory/SetInfo`, queryParams, this.options);
  }

  importAssetCategoryInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/assetCategory/Import`, queryParams, {
      headers: new HttpHeaders({
        Authorization: this.authService.getAuthorizationHeaderValue(),
        'accept': '*/*',
      })
    });
  }

  getAssetCategoryHierarchy(filter = ''): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/assetCategory/GetAssetCategoryHierarchy?filter=${filter}`, this.options)
  }
  getAssetTree(filter = ''): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/assetCategory/GetTree?filter=${filter}`, this.options)
  }

  delAssetCategoryInfo(queryParams: any): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/assetCategory/Delete?${queryParams}`, this.options);
  }

  //api công ty nhận hoá đơn

  getCompanyGetInvoice(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/CompanyGetInvoice/GetPage?${queryParams}`, this.options);
  }

  getCompanyGetInvoiceInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/CompanyGetInvoice/GetInfo?${queryParams}`, this.options);
  }

  setCompanyGetInvoiceInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/CompanyGetInvoice/SetInfo`, queryParams, this.options);
  }

  delCompanyGetInvoice(queryParams: any): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/CompanyGetInvoice/Delete?${queryParams}`, this.options);
  }

  // Báo cáo

  getReportGeneral(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetReportGeneral?${queryParams}`, this.options)
  }

  getReportDetail(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetReportDetail?${queryParams}`, this.options)
  }

  getReportShopping(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetReportShopping?${queryParams}`, this.options)
  }

  getReportStoreInventory(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetReportStoreInventory?${queryParams}`, this.options)
  }

  getReportStatus(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetReportStatus?${queryParams}`, this.options)
  }

  getReportStoreExport(queryParams: any) : Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/asset/GetReportStoreExport?${queryParams}`, this.options)
  }

  getReport(url,queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/report/${url}?${queryParams}`, this.options);
  }

  getExportReport(url,queryParams: any): Observable<Blob> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/report/${url}?${queryParams}`, {
      headers: new HttpHeaders({
        Authorization: this.authService.getAuthorizationHeaderValue(),
      }),
      responseType: "blob"
    });
  }

  // api Hoạt động

  getAssetAction(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/AssetAction/GetPage?${queryParams}`, this.options)
  }

  getActionDetail(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/AssetAction/GetDetailViewInfo?id=${queryParams}`, this.options)
  }

  setAssetActionAllocate(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetAction/SetAssetActionAllocate`, queryParams, this.options);
  }

  setAssetActionEviction(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetAction/SetAssetActionEviction`, queryParams, this.options);
  }

  setAssetActionFailture(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetAction/SetAssetActionFailture`, queryParams, this.options);
  }

  setAssetActionLost(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetAction/SetAssetActionLost`, queryParams, this.options);
  }

  setAssetActionTransfer(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetAction/SetAssetActionTransfer`, queryParams, this.options);
  }

  // api Kiểm kê

  getAssetInventory(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/AssetInventory/GetPage?${queryParams}`, this.options);
  }

  getAssetInventoryInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/AssetInventory/GetInfo?${queryParams}`, this.options);
  }

  setAssetInventoryInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetInventory/SetInfo`, queryParams, this.options);
  }

  getInventoryDetailInfo(id: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/AssetInventory/GetDetailViewInfo?${id}`, this.options);
  }

  delAssetInventory(queryParams: any): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/AssetInventory/Delete?${queryParams}`, this.options);
  }

  setAssetInventoryDetails(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetInventoryDetails/AddList`, queryParams, this.options);
  }

  delAssetInventoryDetails(queryParams: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        Authorization: this.authService.getAuthorizationHeaderValue(),
        'Content-Type': 'application/json',
      }),
      body: queryParams
    };
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/AssetInventoryDetails/DeleteList`, options);
  }

  importInventtory(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetInventory/Import`, queryParams, {
      headers: new HttpHeaders({
        Authorization: this.authService.getAuthorizationHeaderValue(),
        'accept': '*/*'
      })
    });
  }

  setStartInventoryDetails(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetInventory/SetStart`, queryParams, this.options);
  }

  setFinishInventoryDetails(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetInventory/SetFinish`, queryParams, this.options);
  }

  setInventoryDetails(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetInventoryDetails/SetInventory`, queryParams, this.options);
  }

  setInventoryForAssetOther(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/AssetInventoryDetails/SetInventoryForAssetOther`, queryParams, this.options);
  }

  // api công cụ, dụng cụ

  getEquipment(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Equipment/GetPage?${queryParams}`, this.options);
  }

  getEquipmentInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Equipment/GetInfo?${queryParams}`, this.options);
  }

  getEquipmentDetailInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Equipment/GetDetailInfo?${queryParams}`, this.options);
  }

  getEvictionInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Equipment/GetEvictionInfo?${queryParams}`, this.options);
  }

  setEquipment(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Equipment/SetInfo`, queryParams, this.options);
  }

  getDetailEquipmentInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Equipment/GetDetailInfo?${queryParams}`, this.options);
  }

  delEquipment(queryParams: any): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/Equipment/Delete?${queryParams}`, this.options);
  }

  setAllocationEquipment(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Equipment/SetAllocation`, queryParams, this.options);
  }

  setEvictionEquipment(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Equipment/SetEviction`, queryParams, this.options);
  }

  getGetAdditionInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Equipment/GetAdditionInfo?${queryParams}`, this.options);
  }

  getGetConsumeInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Equipment/GetConsumeInfo?${queryParams}`, this.options);
  }

  setAdditionEquipment(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Equipment/SetAddition`, queryParams, this.options);
  }

  setConsumenEquipment(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Equipment/SetConsumen`, queryParams, this.options);
  }

  getPageActionLog(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Equipment/GetPageActionLog?${queryParams}`, this.options);
  }

  getListUserUse(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Equipment/GetListUserUse?${queryParams}`, this.options);
  }

  importEquiment(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Equipment/Import`, queryParams, {
      headers: new HttpHeaders({
        Authorization: this.authService.getAuthorizationHeaderValue(),
        'accept': '*/*'
      })
    });
  }


  // Hình thức đào tạo Type

  getTypePage(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/type/GetPage?${queryParams}`, this.options);
  }

  getTypeInfo(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/type/GetInfo?${queryParams}`, this.options);
  }

  setTypeInfo(queryParams: any): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/type/SetInfo`, queryParams, this.options);
  }

  delTypeInfo(queryParams: any): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/type/Delete?${queryParams}`, this.options);
  }

  // api cấu hình

  getSelectionList(queryParams: any): Observable<any>  {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/SelectionList/Get?${queryParams}`, this.options);
  }


  //apiExport localhost

  exportReportLocalhost(url): Observable<Blob> {
    return this.http.get(url, {
      responseType: "blob"
    });
  }


  // Menu
  getUserMenus(): Observable<any>  {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Menu/GetUserMenus`, this.options);
  }
  getMenuConfigInfo(): Observable<any>  {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Menu/GetMenuConfigInfo`, this.options);
  }
  getConfigMenu(params = '') {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Menu/GetConfigMenu?${params}`, this.options);
  }
  setConfigMenu(data): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Menu/SetConfigMenu`, data, this.options);
  }
  delConfigMenu(menuId): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/Menu/DelConfigMenu?menuId=${menuId}`, this.options);
  }
  getConfigActionList(): Observable<any>  {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/Menu/GetConfigActionList`, this.options);
  }
  setConfigMenuAction(data): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Menu/SetConfigMenuAction`, data, this.options);
  }
  delConfigMenuAction(actionId): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v1/Menu/DelConfigMenuAction?actionId=${actionId}`, this.options);
  }


  // User
  getUserPage(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/user/GetUserPage?${queryParams}`, this.options);
  }

  // Người kiểm kê
  getUserInventory(queryParams: any): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/AssetInventory/GetUserInventory?${queryParams}`, this.options);
  }

  setUserInfo(data): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/user/SetUserInfo`, data, this.options);
  }

  getEmployeeList(paramsQuery): Observable<any> {
    return this.http.get(`${apiServer}/api/v2/employee/GetEmployeeList?` + paramsQuery, this.options);
  }

  getUsersByCust(paramsQuery): Observable<any[]> {
    return this.http
      .get<any[]>(`${apiServer}/api/v1/user/GetUsersByCust?` + paramsQuery, this.options)
  }

  getUserInfo(data) {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/user/GetUserInfo`, data, this.options);
  }

  getRoles(): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v1/user/GetRoles`, this.options);
  }

  setUserAdd(data) {
    return this.http.put(`${apiAssetBaseUrl}/api/v1/user/SetUserAdd`, data, this.options);
  }

  getUserList(queryParams): Observable<any> {
    return this.http
      .get<any>(`${apiAssetBaseUrl}/api/v1/user/GetUserList?` + queryParams, this.options)
  }

  getEmployeeSearch(filter, orgId = null): Observable<any> {
    return this.http
      .get<any>(`${apiHrmServer}/api/v2/employee/GetEmployeeSearch?org_id=${orgId}&filter=` + filter, this.options)
  }

  assetPrinter(data): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/asset/AssetPrinter`, data, this.options);
  }

  getAssetTransferInfo(id): Observable<any> {
    return this.http
      .get<any>(`${apiAssetBaseUrl}/api/v1/asset/GetAssetTransferInfo?id=` + id, this.options)
  }


  getTotalReport(queryParams): Observable<any> {
    return this.http
      .get<any>(`${apiAssetBaseUrl}/api/v1/asset/GetTotalReport?` + queryParams, this.options)
  }

  exportTotalReport(queryParams): Observable<any> {
    return this.http
      .get<any>(`${apiAssetBaseUrl}/api/v1/asset/ExportTotalReport?` + queryParams, this.options)
  }

  getOrganizations(queryParams): Observable<any> {
    return this.http
      .get<any>(`${apiHrmServer}/api/v1/organize/GetOrganizations?` + queryParams, this.options)
  }

  getEmployeeSearchNew(queryParams): Observable<any> {
    return this.http
      .get<any>(`${apiHrmServer}/api/v2/employee/GetEmployeeSearch?` + queryParams, this.options)
  }

  setAssetTransfer(data): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/asset/SetAssetTransfer`, data, this.options);
  }

  setAssetEviction(data): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/asset/SetAssetEviction`, data, this.options);
  }

  //UserRole

  getRolePage(paramsQuery): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v2/userrole/GetRolePage?` + paramsQuery, this.options);
  }

  getRoleInfo(query): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v2/userrole/GetRoleInfo?` + query, this.options);
  }

  getRoleTypes(): Observable<any> {
    return this.http.get(`${apiAssetBaseUrl}/api/v2/userrole/GetRoleTypes`, this.options);
  }

  setRoleInfo(data): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v2/userrole/SetRoleInfo`, data, this.options);
  }

  deleteRole(queryParams): Observable<any> {
    return this.http.delete(`${apiAssetBaseUrl}/api/v2/userrole/DeleteRole?` + queryParams, this.options);
  }

  //api danh sách tất cả tổ chức

  getOrganize(): Observable<any> {
    return this.http
      .get<any>(`${apiAssetBaseUrl}/api/v1/Organize/GetOrganize`, this.options)
  }

  setIpClientInfo(data): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/asset/SetIpClientInfo`, data, this.options);
  }

  setCurrentOrganization(queryParams, data): Observable<any> {
    return this.http.post(`${apiAssetBaseUrl}/api/v1/Organize/SetCurrentOrganization?` + queryParams, data, this.options);
  }

  getOrganizeList(): Observable<any> {
    return this.http
      .get<any>(`${apiAssetBaseUrl}/api/v1/Organize/GetOrganizeList`, this.options)
  }

  getIpClientInfo(): Observable<any> {
    return this.http
      .get<any>(`${apiAssetBaseUrl}/api/v1/asset/GetIpClientInfo`, this.options)
  }

  getUserByOrgt(): Observable<any> {
    return this.http
      .get<any>(`${apiAssetBaseUrl}/api/v1/user/GetUserByOrg`, this.options)
  }

  GetOrganizeTreeNode(): Observable<any> {
    return this.http
     .get<any>('https://apiuniasset.sunshinetech.com.vn/api/v1/asset/GetOrganizeTreeNode', this.options)
  }

  GetEmployeePage(orgId: string): Observable<any> {
    return this.http.get<any>(`${apiHrmServer}/api/v2/employee/GetEmployeePage?filter=&gridWidth=0&offSet=0&pageSize=100000&orgId=${orgId}&isLock=-1&isApprove=-1&emp_st=-1`, this.options)
  }

  setAssetLiquidation(data): Observable<any> {
    return this.postApi(`${apiAssetBaseUrl}/api/v1/asset/SetAssetLiquidation`, data);
  }

  getAssetInsuranceInfo(id): Observable<any> {
    return this.getApi(`${apiAssetBaseUrl}/api/v1/asset/GetAssetInsuranceInfo?id=${id}`);
  }

  setAssetInsurance(data): Observable<any> {
    return this.postApi(`${apiAssetBaseUrl}/api/v1/asset/SetAssetInsurance`, data);
  }

  getAssetInsuranceEnterInfo(id) : Observable<any> {
    return this.getApi(`${apiAssetBaseUrl}/api/v1/asset/GetAssetInsuranceEnterInfo?id=${id}`)
  }

  setAssetInsuranceEnter(data) : Observable<any> {
    return this.postApi(`${apiAssetBaseUrl}/api/v1/asset/SetAssetInsuranceEnter`, data)
  }

  setResetPassword(password): Observable<any> {
    return this.http.put<any>(`${apiCoreBaseUrl}/api/v1/coresystem/SetResetPassword`, password, this.options);
  }

  getWebManagements(): Observable<any> {
    return this.http.get(`${apiConfigServer}/api/v1/webmanager/GetWebManagements`, this.options);
  }

}
